export const kakaotalk = 'https://open.kakao.com/o/s4KFGuCg';
